var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('basic-heading',{staticClass:"mb-3",attrs:{"title":"Managed Lists"}}),_c('permission-alert-gate',{attrs:{"permissions":'list managed list'},scopedSlots:_vm._u([{key:"gated-content",fn:function(){return [_c('managed-lists-table')]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }